import React from 'react';
import { useTranslation } from 'react-i18next';

import { SessionProviderModel } from '../../../gamma-api';
import IbButton from '../common/IbButton';
import IbIcon from '../common/IbIcon';
import IbSpin from '../common/IbSpin';

import './index.less';

const MAIN_CLASS_NAME = 'auth-card';
const LABEL_CLASS_NAME = `${MAIN_CLASS_NAME}__label`;

export interface IAuthCardProps {
  provider: SessionProviderModel;
  onSignIn?: (provider: SessionProviderModel) => void;
  onCancel?: (provider: SessionProviderModel) => void;
}

const AuthCard: React.FC<IAuthCardProps> = ({ provider, onSignIn, onCancel }) => {
  const { t } = useTranslation();
  const [processing, setProcessing] = React.useState(false);

  const onSingInButtonClick = () => {
    setProcessing(true);
    onSignIn?.(provider);
  };

  const onCancelButtonClick = () => {
    setProcessing(false);
    onCancel?.(provider);
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <div className={LABEL_CLASS_NAME}>{t('Auth Card: Label')}</div>
      <IbButton
        disabled={processing}
        icon={processing ? <IbSpin size="small" /> : <IbIcon iconName="logout" />}
        type="primary"
        onClick={onSingInButtonClick}
      >
        {t('Auth Card: Agree')}
      </IbButton>
      {processing && (
        <IbButton status="error" type="secondary" onClick={onCancelButtonClick}>
          {t('Auth Card: Cancel')}
        </IbButton>
      )}
    </div>
  );
};

export default AuthCard;
